<!-- =========================================================================================
    File Name: LockScreen.vue
    Description: Lock Screen Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter justify-center items-center">
        <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/lock-screen.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Admin Login</h4>
                                    <vs-alert v-if="errorMessage" icon="warning" active="true" color="warning" class="my-5">
                                    {{errorMessage}}
                                </vs-alert>
                                </div>
                                <vs-input icon="icon icon-user" icon-pack="feather" label-placeholder="Username" v-model="form.userName" class="w-full mb-6 no-icon-border"/>
                                <vs-input @keyup.enter="login()" icon="icon icon-lock" icon-pack="feather" type="password" label-placeholder="Password" v-model="form.password" class="w-full mb-6 no-icon-border" />
                                <div class="flex justify-between flex-wrap">
                                <vs-button id="button-with-loading" class="float-center vs-con-loading__container" @click="login">Login</vs-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form:{
            userName: '',
            password: '' 
            } ,
            errorMessage:""
        }
    },
    methods:{
        openLoading() {
            this.$vs.loading({
                background: 'primary',
                color: '#fff',
                container: "#button-with-loading",
                scale: 0.45
            })
        },
        login(){
            this.openLoading();
              this.$http.post("admin/adminLogin",JSON.stringify(this.form),
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                .then(response => {
                    this.$session.start();
                    this.$session.set("adminId", response.data.data.userId);
                    this.$session.set("adminName", response.data.data.userName);
                    this.$session.set("adminCategoryId", response.data.data.userCategoryId);
                    this.$session.set("adminToken", response.data.data.userToken);
                    this.$session.set("companyName", 'Admin');
                    this.$router.push('/admin/dashboard');
                })
                .catch(error=>{
                    this.errorMessage="Invalid Login";
                    this.$vs.loading.close("#button-with-loading > .con-vs-loading")
                })
        }
    }
}
</script>
